<template>
    <div id="banner-container" class="bg-cover">
        <!-- <a href="/"><img id="banner" src="../assets/knights_banner.png"></a> -->
        <a href="/"><img id="banner" :src="bannerURL"></a>

    </div>
</template>


<script>

export default {
  props: ['bannerURL'],
  name: 'links',
  components: {
    
  },

}
</script>

<style scoped>
#banner-container{
	margin-left: auto;
	margin-right: auto;
	display: flex;
	justify-content: center;
	align-items: center;
}

.sign_1 {
	background-image: url('../assets/sign_1.png');
}

#banner{
    /*background-image: url('../assets/knights_banner.png');*/
    max-width:100%;
	max-height:100%;
}

</style>